import PropTypes from 'prop-types';
import React, { Component } from 'react';
import InAppBar from '../core/InAppBar';
import ClassView from './ClassView';
import PropertyView from './PropertyView';
import NamedIndividualView from './NamedIndividualView';
import DatatypeView from './DatatypeView';
import { EDITING_OPTIONS } from '../application-core/constants';

class OntologyEditor extends Component {

  render() {

    const { project, defaultLang, ontologyIRI, expandNode, collapseNode, onBreakLink, onAddNewNode, onDeleteNode, onCollapse,
      onChangeTab, onShowDetail, buildLink, graph, onFound, tabValue, activeClass, selectedTitlePath, onAddExistingNode, hiddenProps,
      expandedPaths, expandedClasses, foundPath, foundRef, foundTime, expandedProperties, viewLang, isFullView, viewWidth,
      onViewWidthChange, onFullViewChange, useSlashIRI, useUuidIRI, iriOptions, excludeDeprecated, editingOptions, propertyTemplates,
      activeDatatypeProperty, activeObjectProperty, activeAnnotationProperty, activeNamedIndividual, activeDatatype,
      onSelectViewLanguage, availableAnnotationProperty, useWorkflow, entitlements, projectUsers } = this.props;

    const av = editingOptions && editingOptions.includes(EDITING_OPTIONS.ADVANCED_VIEW);

    let tabItems = [
      { label: "Classes", name: "Class" },
      { label: <span>Object<br /><span style={{ fontSize: '10px' }}>Properties</span></span>, name: "Object" },
      { label: <span>Datatype<br /><span style={{ fontSize: '10px' }}>Properties</span></span>, name: "Datatype" },
      { label: <span>Annotation<br /><span style={{ fontSize: '10px' }}>Properties</span></span>, name: "Annotation" }
    ];
    if (av) {
      tabItems.push({ label: <span>Named<br /><span style={{ fontSize: '10px' }}>Individuals</span></span>, name: "Named" });
      tabItems.push({ label: "Datatypes", name: "Datatypes" });
    }

    const appBar = <InAppBar
      tabValue={tabValue}
      deep={true}
      onChangeTab={onChangeTab}
      size="small"
      tabItems={tabItems} />;

    return (
      <React.Fragment>
        {tabValue === 0 &&
          <ClassView
            id="http://www.w3.org/2002/07/owl#Thing"
            appBar={appBar}
            advancedView={av}
            entitlements={entitlements}
            projectUsers={projectUsers}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            useWorkflow={useWorkflow}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[0]}
            excludeDeprecated={excludeDeprecated}
            activeClass={activeClass}
            expandedPaths={expandedPaths}
            expandedClasses={expandedClasses}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            titlePath={[]}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onBreakLink={onBreakLink("hasSubClass")}
            onAddExistingClass={onAddExistingNode("hasSubClass")}
            onAddNewClass={onAddNewNode(tabValue)}
            onDeleteClass={onDeleteNode}
            onFoundClass={onFound(tabValue)}
            onSelect={onShowDetail(tabValue)}
            ontologyIRI={ontologyIRI}
            editingOptions={editingOptions}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
        {tabValue === 1 &&
          <PropertyView
            id="http://www.w3.org/2002/07/owl#topObjectProperty"
            searchClass="http://www.w3.org/2002/07/owl#ObjectProperty"
            appBar={appBar}
            advancedView={av}
            entitlements={entitlements}
            projectUsers={projectUsers}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            useWorkflow={useWorkflow}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[1]}
            activeProperty={activeObjectProperty}
            excludeDeprecated={excludeDeprecated}
            expandedPaths={expandedPaths}
            expandedProperties={expandedProperties}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            titlePath={[]}
            childProperty="hasSubProperty"
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onBreakLink={onBreakLink("hasSubProperty")}
            onAddExistingNode={onAddExistingNode("hasSubProperty")}
            onAddNewNode={onAddNewNode(tabValue)}
            onDeleteNode={onDeleteNode}
            onFoundProperty={onFound(tabValue)}
            editingOptions={editingOptions}
            onSelect={onShowDetail(tabValue)}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
        {tabValue === 2 &&
          <PropertyView
            id="http://www.w3.org/2002/07/owl#topDataProperty"
            searchClass="http://www.w3.org/2002/07/owl#DatatypeProperty"
            appBar={appBar}
            advancedView={av}
            entitlements={entitlements}
            projectUsers={projectUsers}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            useWorkflow={useWorkflow}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[2]}
            activeProperty={activeDatatypeProperty}
            excludeDeprecated={excludeDeprecated}
            expandedPaths={expandedPaths}
            expandedProperties={expandedProperties}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            titlePath={[]}
            childProperty="hasSubProperty"
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onBreakLink={onBreakLink("hasSubProperty")}
            onAddExistingNode={onAddExistingNode("hasSubProperty")}
            onAddNewNode={onAddNewNode(tabValue)}
            onDeleteNode={onDeleteNode}
            onFoundProperty={onFound(tabValue)}
            editingOptions={editingOptions}
            onSelect={onShowDetail(tabValue)}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
        {tabValue === 3 &&
          <PropertyView
            id="https://graphifi.com/schema/xowl/topAnnotationProperty"
            searchClass="http://www.w3.org/2002/07/owl#AnnotationProperty"
            appBar={appBar}
            advancedView={av}
            entitlements={entitlements}
            projectUsers={projectUsers}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            useWorkflow={useWorkflow}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[3]}
            activeProperty={activeAnnotationProperty}
            excludeDeprecated={excludeDeprecated}
            expandedPaths={expandedPaths}
            expandedProperties={expandedProperties}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            titlePath={[]}
            childProperty="hasSubAnnotationProperty"
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onBreakLink={onBreakLink("hasSubAnnotationProperty")}
            onAddExistingNode={onAddExistingNode("hasSubAnnotationProperty")}
            onAddNewNode={onAddNewNode(tabValue)}
            onDeleteNode={onDeleteNode}
            onFoundProperty={onFound(tabValue)}
            onSelect={onShowDetail(tabValue)}
            editingOptions={editingOptions}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
        {tabValue === 4 &&
          <NamedIndividualView
            id="http://www.w3.org/2002/07/owl#Thing"
            searchClass="http://www.w3.org/2002/07/owl#NamedIndividual"
            appBar={appBar}
            advancedView={av}
            entitlements={entitlements}
            projectUsers={projectUsers}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            propertyTemplates={propertyTemplates}
            useWorkflow={useWorkflow}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[4]}
            activeNamedIndividual={activeNamedIndividual}
            excludeDeprecated={excludeDeprecated}
            expandedPaths={expandedPaths}
            expandedProperties={expandedProperties}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            titlePath={[]}
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            childProperty="hasNamedIndividual"
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onAddExistingNode={onAddExistingNode("hasNamedIndividual")}
            onAddNewNode={onAddNewNode(tabValue)}
            onDeleteNode={onDeleteNode}
            onFoundNamedIndividual={onFound(tabValue)}
            onSelect={onShowDetail(tabValue)}
            editingOptions={editingOptions}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
        {tabValue === 5 &&
          <DatatypeView
            id="http://www.w3.org/2002/07/owl#Thing"
            searchClass="http://www.w3.org/2000/01/rdf-schema#Datatype"
            appBar={appBar}
            advancedView={av}
            entitlements={entitlements}
            projectUsers={projectUsers}
            graph={graph}
            iriOptions={iriOptions}
            buildLink={buildLink}
            useWorkflow={useWorkflow}
            availableAnnotationProperty={availableAnnotationProperty}
            selectedTitlePath={selectedTitlePath[5]}
            activeDatatype={activeDatatype}
            excludeDeprecated={excludeDeprecated}
            expandedPaths={expandedPaths}
            expandedProperties={expandedProperties}
            foundPath={foundPath}
            foundRef={foundRef}
            foundTime={foundTime}
            hiddenProps={hiddenProps}
            project={project}
            viewLang={viewLang}
            onSelectViewLanguage={onSelectViewLanguage}
            titlePath={[]}
            defaultLang={defaultLang}
            expandNode={expandNode}
            collapseNode={collapseNode}
            isFullView={isFullView}
            viewWidth={viewWidth}
            onCollapse={onCollapse}
            childProperty="hasRdfsDatatype"
            onViewWidthChange={onViewWidthChange}
            onFullViewChange={onFullViewChange}
            onAddExistingNode={onAddExistingNode("hasRdfsDatatype")}
            onAddNewNode={onAddNewNode(tabValue)}
            onDeleteNode={onDeleteNode}
            onFoundDatatype={onFound(tabValue)}
            onSelect={onShowDetail(tabValue)}
            editingOptions={editingOptions}
            ontologyIRI={ontologyIRI}
            useSlashIRI={useSlashIRI}
            useUuidIRI={useUuidIRI}
          />
        }
      </React.Fragment>
    );
  }

}

OntologyEditor.propTypes = {
  buildLink: PropTypes.func.isRequired,
  graph: PropTypes.string.isRequired,
  propertyTemplates: PropTypes.array,
  entitlements: PropTypes.array.isRequired,
  projectUsers: PropTypes.array,
  activeClass: PropTypes.string,
  activeDatatypeProperty: PropTypes.string,
  activeObjectProperty: PropTypes.string,
  activeAnnotationProperty: PropTypes.string,
  activeNamedIndividual: PropTypes.string,
  expandedPaths: PropTypes.array,
  expandedClasses: PropTypes.array,
  expandedProperties: PropTypes.array,
  excludeDeprecated: PropTypes.bool,
  foundPath: PropTypes.string,
  foundRef: PropTypes.object,
  foundTime: PropTypes.number,
  viewLang: PropTypes.string,
  onSelectViewLanguage: PropTypes.func.isRequired,
  selectedTitlePath: PropTypes.array,
  ontologyIRI: PropTypes.string.isRequired,
  useSlashIRI: PropTypes.bool,
  useUuidIRI: PropTypes.bool,
  project: PropTypes.string.isRequired,
  useWorkflow: PropTypes.bool,
  tabValue: PropTypes.number.isRequired,
  expandNode: PropTypes.func.isRequired,
  collapseNode: PropTypes.func.isRequired,
  onAddExistingNode: PropTypes.func.isRequired,
  onAddNewNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired,
  onFound: PropTypes.func.isRequired,
  onBreakLink: PropTypes.func.isRequired,
  onChangeTab: PropTypes.func.isRequired,
  onShowDetail: PropTypes.func.isRequired,
  onCollapse: PropTypes.func,
  isFullView: PropTypes.bool,
  hiddenProps: PropTypes.array,
  editingOptions: PropTypes.array,
  onFullViewChange: PropTypes.func.isRequired,
  onViewWidthChange: PropTypes.func.isRequired,
  availableAnnotationProperty: PropTypes.array,
  defaultLang: PropTypes.string.isRequired,
  iriOptions: PropTypes.object
};

export default OntologyEditor;